export default {
  baseURL: process.env.NODE_ENV !== 'production' ? 'https://dlc.develop.fonixapis.com' : 'https://dlc.fonixapis.com',
  debug: process.env.NODE_ENV !== 'production'
}



// WEBPACK FOOTER //
// ./src/services/config.js